<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-15 11:49:17
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-08-20 09:57:38
 * @FilePath: /bpm-form/src/components/wgForm/widget-items/wg-text.vue
 * @Description: 描述
 -->

<template>
  <div widget-type="html">
    <div :class="options.customClass"
      :data-model="fieldName"
      v-html="value"></div>
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
};
</script>
